<template>
    <div id="workman">
        <van-search
                ref="search"
                placeholder="请输入要查询的工号"
                v-model="searchKey"
                show-action
                @search="onSearch(searchKey)">
            <div slot="action" @click="onSearch(searchKey)">搜索</div>
        </van-search>
        <div class="body-padding order-tabs-list">
            <van-pull-refresh
                    v-model="loading"
                    style="overflow:unset;padding-bottom: 1.7rem;height: 100%;box-sizing: border-box;"
                    @refresh="onRefresh">
                <van-list
                        :finished="finished"
                        @load="onLoad">
                    <workman-item v-for="item in list" :key="item.id" :item="item"></workman-item>
                </van-list>
            </van-pull-refresh>
        </div>
    </div>
</template>

<script>
    import {Toast} from "vant";

    export default {
        name: "HenanWorkman",
        data() {
            return {
                searchKey: '',
                loading: false,
                finished: false,
                list: []
            }
        },
        components: {
            WorkmanItem: () => import('@/components/WorkmanItem')
        },
        methods: {
            onSearch() {
                if (!this.searchKey) {
                    Toast({
                        message: "请输入工号",
                        duration: 2000
                    });
                    return;
                }
                this.getList()
            },
            // 下拉刷新
            onRefresh() {
                setTimeout(() => {
                    this.$toast('刷新成功')
                    this.loading = false
                }, 500);
            },
            // 加载
            onLoad() {
                //this.loading = false
                //this.finished = true
            },
            getList() {
                let params = {
                    params: {
                        sid: this.searchKey,
                        logisticsCompanyId: "d76f55b11f7b4fdc9a2128a99a5f803d",
                    }
                }
                this.$axios.post('/workman/list', params).then(res => {
                    if (res.data.code === 200) {
                        this.list = res.data.data;
                        this.list.forEach(item => {
                            if ((item.sid + "").length == 2) {
                                item.sid = "0" + item.sid
                            } else if ((item.sid + "").length == 1) {
                                item.sid = "00" + item.sid
                            }
                        })
                    }
                });
            }
        }
    }
</script>

<style lang="scss">
    #workman {
        overflow: hidden;

        .body-padding {
            //padding: 0.08rem 0.27rem;
        }

        .order-tabs {
            //display: flex;
            //flex-direction: column;
            //flex: 1;
        }

        .order-tabs-list {
            //height: 100%;
            //overflow-y: scroll;
        }

        .van-pull-refresh__head {
            z-index: -1;
        }
    }
</style>
